import * as React from 'react';
import './index.css';
import { View } from '@wmfe/mach-pro-components-react';
import { reportBizCardMetrics } from '@/src/utils/bizCardReporter';
import ImgBottomLabel from '../ImgBottomLabel';
import { attachments } from '../ContentItems';
import { reportProductMc, reportProductMv } from './LX';

const WMRouter = Mach.requireModule('Router');

interface IState {
}

interface IProps {
  log_info: any;
  subCards: any[]; // 通用商卡数据list
  cardsItemsSpec?: number; // 卡片间距 默认 8
  marginRight?: number;
  hasTopLine?: boolean;
}

class FeedsProductListComponent extends React.Component<IProps, IState> {
  itemRefFrameMap = {};
  scrollerRef: any;
  warpWidth: number = 0;

  constructor(props) {
    super(props);
  }

  componentDidUpdate(prevProps: Readonly<IProps>): void {
    const dataChanged = this.props?.subCards !== prevProps?.subCards;
    if (dataChanged) {
      this.scrollerRef?.scrollToOffset?.({ x: 0, y: 0 }, false);
    }
  }

  getCustomContentItemStyle({ type }: {type: string; }) {
    if (type === 'spuFinalPrice') {
      return {
        maxLines: 1,
        customProperty: {
          fontSize: 12,
        }
      };
    }
    return {
      maxLines: 1
    };
  }

  onScrollEnd = (scrollState) => {
    const { subCards = [] } = this.props;

    if (this.warpWidth > 0 && subCards.length !== globalThis.reportSet?.size) {
      subCards.forEach((item, index) => {
        const frame = this.itemRefFrameMap[index];
        const { dataId } = this.props.log_info;
        const key = `${dataId}_${index}`;
        if (!frame || globalThis.reportSet?.has?.(key)) return;

        const itemOffsetX = Number(frame.x);
        const itemWidth = Number(frame.width);
        const scrollerWidth = this.warpWidth;
        const scrollerOffsetX = Number(scrollState.x);

        const itemStart = itemOffsetX;
        const itemEnd = itemOffsetX + itemWidth;
        const scrollerStart = scrollerOffsetX;
        const scrollerEnd = scrollerOffsetX + scrollerWidth;

        if (itemStart < scrollerEnd && itemEnd > scrollerStart) {
          this.lxReportItemOnShow(index);
        }
      });
    }
  }

  lxReportItemOnShow = (index: number) => {
    const { dataId } = this.props.log_info;
    const key = `${dataId}_${index}`;
    if (globalThis.reportSet?.has?.(key)) {
      return;
    }

    globalThis.reportSet?.add?.(key);
    const { subCards = [], log_info } = this.props;
    const logData = subCards?.[index]?.logData || {};
    reportProductMv({ cid: log_info?.cid || '', logData: { ...logData, item_index: index } });

    const picImage = subCards?.[index]?.pictures?.[0]?.url || subCards?.[index]?.shopMainPicUrl;
    const shopMainPicMissing = picImage !== null && picImage ? 0 : 1;
    reportBizCardMetrics({
      params: { shopMainPicMissing },
      tags: {
        channel: '下挂菜通用商-下挂菜'
      }
    });
  }

  onClickScheme = (data: any, index: number) => {
    const scheme = data?.pictures?.[0]?.scheme || data?.scheme;

    const { log_info } = this.props;
    const logData = data?.logData || {};
    reportProductMc({ cid: log_info?.cid || '', logData: { ...logData, item_index: index } });

    if (scheme) {
      WMRouter.navigateTo(scheme, { }, () => {});
    }
  }

  renderSubCards = (data: any, cardIndex: number, isLast: boolean) => {
    const pictureUrl = data?.pictures?.[0]?.url || data?.shopMainPicUrl;

    const imgBottomLabel = data?.imgBottomLabel;

    const content = data?.content || [];
    const { cardsItemsSpec = 8, marginRight = 12 } = this.props;

    return (
      // 菜品卡片
      <View
        className="product-card-warp" style={isLast ? { marginRight } : { marginRight: cardsItemsSpec }} onLayout={(frameEvent) => {
          this.itemRefFrameMap[cardIndex] = frameEvent.detail;
        }} onView={(status: boolean) => {
          if (status) {
            // console.log('onView ', cardIndex);
            this.onScrollEnd({ x: 0, y: 0 });
          }
        }}
        onClick={() => {
          this.onClickScheme(data, cardIndex);
        }}
      >
        {/* 商品图 */}
        <view className="product-card-header-warp">
          <image
            className="product-card-header-picture"
            style={Mach.env.isAndroid ? { borderRadius: 9 } : undefined}
            resizeMode="aspectFill"
            placeholder="assets://placeholder/icon_placeholder_4:3.png"
            src={
              pictureUrl || 'assets://placeholder/icon_placeholder_4:3.png'
            }
            error="assets://placeholder/icon_placeholder_4:3.png"
          />
          <view className="product-card-header-picture-placeholder" />
          {/* 腰封 */}
          {imgBottomLabel ? <view className="product-card-header-bottom-label"><ImgBottomLabel imgBottomLabel={imgBottomLabel} absoluteStyle /></view> : null}
        </view>

        {/* 标签 二维数组 */}
        <view className="product-card-content-item-warp">
          {content.map((warp, line) => (
            <view className="product-card-content-item-line">
              {warp.map((item, index) => {
                const attachmentData = attachments[item?.type];
                const customStyles = this.getCustomContentItemStyle({
                  type: item.type,
                });
                const lastAttachmentData = attachments[warp?.[Number(index) + 1]?.type];
                if (attachmentData) {
                  return (
                    <attachmentData.attachment
                      key={`item.type_${line}_${index}`}
                      data={item?.data}
                      line={line}
                      index={index}
                      itemKey={item?.type}
                      hasLastItem={lastAttachmentData !== undefined}
                      style={customStyles}
                    />
                  );
                }
                return null;
              })}
            </view>
          ))}
        </view>
      </View>
    );
  }

  render() {
    const { subCards = [], hasTopLine = true, marginRight = 12 } = this.props;

    if (!(subCards || []).length) return null;

    return (
      <view
        className="product-list-content"
        onLayout={(frameEvent) => {
          this.warpWidth = frameEvent.detail.width;
        }}
      >
        {/* line */}
        {hasTopLine && <view className="product-list-top-line" style={{ marginRight }} />}
        <scroller
          flexibleHeight
          showScrollIndicator={false} onScrollEnd={this.onScrollEnd}
          ref={(ref: any) => {
            if (ref) {
              this.scrollerRef = ref;
            }
          }}
        >
          <content>
            {(subCards || []).map((item, index) => (
              this.renderSubCards(item, index, index === subCards.length - 1)
            ))}
          </content>
        </scroller>
      </view>
    );
  }
}

export default FeedsProductListComponent;
